module.exports = __webpack_public_path__ + "static/media/black-return-icon.621557a4.svg";